import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const UPDATE_BIDDER_SUPPLY_CHAIN: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateWorkspaceBiddersForSupplyChainTable($input: BulkUpdateWorkspaceBidderInput!) {
    bulkUpdateWorkspaceBidder(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
